module.exports = __webpack_public_path__ + "assets/img/detail-content-img-3-2c60837b.jpg";